export default __webpack_public_path__ + "static/media/wreckingball-ult.1652f10e.mp3";